import FileUploaderIcon from '../FileUploaderIcon/FileUploaderIcon'
import React, { ReactElement } from 'react'
import { Icon, IconType } from '@conekta/frontino-ui/Icon/Icon'
import { ILeftSide } from '../../interface'
import { LeftSideDescription } from './components/LeftSideDescription'
import { Tooltip } from 'components/Tooltip/Tooltip'
import './LeftSide.scss'

const LeftSide = ({
  defaultFileName,
  defaultFileURL,
  disabled,
  errorMessage,
  fileDesc,
  fileName,
  fileTitle,
  fileTypes,
  isFileAccepted,
  isFileRejected,
  tooltip
}: ILeftSide): ReactElement | null => {
  return (
    <div className='left-side'>
      <div className='indication'>
        <FileUploaderIcon {...{ disabled, errorMessage, isFileAccepted, isFileRejected }} />
        <div className='indication-description'>
          <h6 className='indication-description-name'>
            {fileTitle}
            {tooltip && (
              <Tooltip title={tooltip.title} content={tooltip.description || ''} withoutBorder>
                <Icon className='indication-description-name-icon' size='small' type={IconType.OUTLINED}>
                  info
                </Icon>
              </Tooltip>
            )}
          </h6>
          <LeftSideDescription
            defaultFileName={defaultFileName}
            defaultFileURL={defaultFileURL}
            fileTypes={fileTypes}
            fileName={fileName}
            isFileAccepted={isFileAccepted}
            fileDesc={fileDesc}
            errorMessage={errorMessage}
            isFileRejected={isFileRejected}
          />
        </div>
      </div>
    </div>
  )
}

export default LeftSide
